import React from 'react'
import injectSheet from 'react-jss'
import { BudgetSliderHandle, BudgetSliderLegend } from '../../'

class BudgetSlider extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      track: props.theme.sizes.smallContainer,
    }

    this.setTrack = this.setTrack.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', () => this.setTrack())
    this.setTrack()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setTrack, false)
  }

  setTrack() {
    if (this.track) {
      this.setState({
        track: this.track.clientWidth,
      })
    }
  }

  render() {
    const {
      classes, budget, budgetOverview, leftBound, setBudget,
    } = this.props

    const { track } = this.state

    return (
      <div className={`${classes.layoutContainer}`}>
        <div className={`${classes.sideContainer}`} />
        <div className={`${classes.trackContainer}`}>
          <div
            className={`${classes.track}`}
            ref={(node) => {
              this.track = node
            }}
          >
            <div>
              <BudgetSliderHandle
                blocker={budget.blocker}
                currency={budget.config.currency}
                hasBlock={budget.handle.hasBlock}
                increment={budget.config.increment}
                initialPos={
                  !budgetOverview.total
                    ? budget.handle.value
                    : budgetOverview.total
                }
                leftBound={leftBound}
                rightBound={budget.config.maxBudget}
                setBudget={setBudget}
                sliderMax={budget.config.maxBudget}
                title={budget.config.title}
                track={track}
              />
            </div>
          </div>
        </div>
        <div className={`${classes.sideContainer}`}>
          <BudgetSliderLegend budget={budget} budgetOverview={budgetOverview} />
        </div>
      </div>
    )
  }
}

const styles = theme => ({
  layoutContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    [theme.media.large]: {
      flexWrap: 'nowrap',
    },
  },
  sideContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    [theme.media.large]: {
      width: `calc(100% - ${theme.sizes.smallContainer / 2 -
        theme.sizes.gutter}px)`,
    },
    '& > div': {
      width: '100%',
      maxWidth: `${theme.sizes.smallContainer}px`,
    },
  },
  trackContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: `40px ${theme.sizes.gutter / 2}px 80px ${theme.sizes.gutter /
      2}px`,
    '& > div': {
      width: '100%',
      maxWidth: `${theme.sizes.smallContainer}px`,
    },
  },
  track: {
    position: 'relative',
    width: '100%',
    height: '20px',
    backgroundColor: `${theme.colors.secondary_3a}`,
    borderRadius: '5px',
  },
  range: {
    position: 'absolute',
    top: '50%',
    color: theme.colors.main_1,
    padding: '0 10px',
    '&.min': {
      left: 0,
      transform: 'translate(-100%, -50%)',
    },
    '&.max': {
      right: 0,
      transform: 'translate(100%, -50%)',
    },
  },
  handleValueFormat: {
    display: 'block',
    width: 'max-content',
    color: theme.colors.main_1,
    backgroundColor: theme.colors.main_2,
  },
})

export default injectSheet(styles)(BudgetSlider)



// WEBPACK FOOTER //
// ./src/modules/budget/components/budgetSlider.jsx